import Footer from "components/footer/Footer.comp";
import Header from "components/header/Header.comp";
import LoadTicket from "pages/loadTicket";
import ListTickets from "pages/tickets/list/listTickets.page";
import { ContextProvider } from "providers/ContextProvider";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "styles/main.scss";
import DataDeletion from "./pages/data-deletion/dataDeletion.page";
import CreateTicket from "./pages/tickets/create/createTicket.page";
import InternalRoot from "./internal/InternalRoot";
import ShareIssuePage from "./internal/pages/ShareIssuePage";

function AppShell() {
    const location = useLocation();
    const isInternal = location.pathname.startsWith("/internal");
    const isShare = location.pathname.startsWith("/share");
    const hideChrome = isInternal || isShare;

    return (
        <ContextProvider>
            {!hideChrome ? <Header /> : null}
            <Routes>
                <Route path="/internal/*" element={<InternalRoot />} />
                <Route path="/share/issue/:token" element={<ShareIssuePage />} />
                <Route path="/" element={<CreateTicket />} />
                <Route path="/data-deletion" element={<DataDeletion />} />
                <Route path="/fileUploads/load/:fileId" element={<LoadTicket />} />
                <Route path="/ls" element={<ListTickets />} />
            </Routes>
            {!hideChrome ? <Footer /> : null}
        </ContextProvider>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppShell />
        </BrowserRouter>
    );
}

export default App;
